import { render, staticRenderFns } from "./YamlEditor.vue?vue&type=template&id=37805641&scoped=true"
import script from "./YamlEditor.vue?vue&type=script&lang=js"
export * from "./YamlEditor.vue?vue&type=script&lang=js"
import style0 from "./YamlEditor.vue?vue&type=style&index=0&id=37805641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37805641",
  null
  
)

export default component.exports